var _style, _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCash = function SvgCash(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "cash_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 550.35 550.35",
    style: {
      enableBackground: "new 0 0 550.35 550.35"
    },
    xmlSpace: "preserve"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".cash_svg__st1{fill:#00ff52;stroke:#000;stroke-width:20;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}")), /*#__PURE__*/React.createElement("circle", {
    cx: 275.17,
    cy: 275.17,
    r: 275.17,
    style: {
      fill: "#e5e5e5"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-39.649 226.673 255.199)",
    className: "cash_svg__st1",
    d: "M86.12 171.9h281.16v166.64H86.12z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-32.552 269.777 274.226)",
    className: "cash_svg__st1",
    d: "M129.2 190.92h281.16v166.64H129.2z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    transform: "rotate(-22.256 314.72 307.4)",
    className: "cash_svg__st1",
    d: "M174.09 224.07h281.16v166.64H174.09z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M296.66 260.13c3.49-1.43 7.39.21 8.82 3.7l.69 1.68c6.89-1.7 13.45-2.14 19.81-1.37 2.83.39 5.81 1.84 7.29 5.44 1.87 4.57-.31 9.54-4.88 11.41-1.44.59-3.03.82-4.65.64-4.11-.43-8.07-.49-11.66 0l7.49 18.29c20.31-2.55 31.18 1.71 36.7 15.18 5.52 13.48-1.28 26.37-15.75 34.26l2.61 6.38a6.72 6.72 0 0 1-3.69 8.82c-3.49 1.43-7.39-.21-8.82-3.7l-2.66-6.5c-8.99 2.41-18.28 2.7-27.15 1.28-3.17-.53-5.72-2.3-7.05-5.54-1.92-4.69.26-9.66 4.95-11.58 1.56-.64 3.49-.73 5.33-.36 6.38 1.18 12.13 1.5 18.16.43l-7.83-19.13c-19.25 2.4-30.5-.72-36.36-15.04-5.42-13.23 1.04-26.27 15.56-34.04l-.59-1.44c-1.45-3.48.19-7.38 3.68-8.81zm10.3 41.3-6.65-16.24c-5.43 3.21-6.78 7.13-5.2 10.98 1.53 3.73 4.24 5.56 11.85 5.26zm19.93 16.43 6.85 16.72c5.31-3.16 7.11-6.99 5.34-11.32-1.63-3.97-4.76-5.78-12.19-5.4z"
  })));
};

export default SvgCash;